//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";

export default {
  name: 'RelatedObjects',
  components: {
    IconView
  },
  props: {
    label: {
      type: String,
      required: true,
      default: () => ''
    },
    slug: {
      type: String,
      required: true,
      default: () => ''
    },
    objects: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    getImageUrl(object) {
      if (!object.has_image) {
        return ""
      } else {
        return `/public/object_images_files/first_image/${object.id}/?preview=1`
      }
    }
  }
}
